

































import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { VectorImageLayer } from '@/model/document2/page/surface/design/layer/vectorImageLayer';
import { SVGPathData, SVGPathDataTransformer, SVGPathDataParser } from 'svg-pathdata';
import { ImageHelper } from '@/helper/imageHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { Vector2 } from '@/utilityModels/vector2';
import { Rectangle } from '@/utilityModels/rectangle';
import { ResourceHelper } from '@/helper/resourceHelper';

@Component({
    components: {
    },
})
export default class VectorImageLayerDrawer extends Vue {

    @Prop() private layer!: VectorImageLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    @Prop({default : false}) private useThumbnail! : boolean;
    @Prop({ default: false }) private isInEditor! : boolean;

    // ViewのUUID
    private uuid = "";
    // 画像のエラーフラグ
    private isImageError = false;
    // 画像にエラーがあるときに表示する画像
    private get errorImageSource()
    {
        return ResourceHelper.getResource('error_img.svg');
    }
    // 差し込みかどうか
    private get isInsertion() { return this.layer.isInsertion; }

    private get isVisibleErrorImage()
    {
        return !this.layer.isInsertion || this.isInEditor;
    }

    mounted()
    {
       this.uuid = UuidHelper.getUuid();
    }

    private get opacity() { return MathHelper.clamp(this.layer.opacity / 100, 0, 1); }

    public get imageSource() : string
    {
        if(this.layer.whiteTransparent)
        {
            if(this.useThumbnail && this.layer.thumbnailImageWhiteTransparent != "")
            {
                return this.layer.thumbnailImageWhiteTransparent;
            }
            else
            {
                return this.layer.imageBase64WhiteTransparent;
            }
        }
        else
        {
            if(this.useThumbnail && this.layer.thumbnailImage != "")
            {
                return this.layer.thumbnailImage;
            }
            else
            {
                return this.layer.imageBase64;;
            }
        }
    }

    private get insertionImageSource()
    {
        // JSでは外部リソースに手を加えられないので白色透明化はなし
        return this.layer.insertionContent;
    }

    public get width() : number
    {
        return this.layer.width * (this.layer.width < 0 ? -1 : 1);
    }

    public get height() : number
    {
        return this.layer.height * (this.layer.height < 0 ? -1 : 1);
    }

    public get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // スケーリング
        transform += "scale(" + this.scale + ")";

        // フリップ
        if(this.layer.flipHorizontal || this.layer.flipVertical)
        {
            transform += ",";

            // x, yでスケーリングするとき、座標を補正して原点が変わらないようにする。
            var flipScaleX = this.layer.flipHorizontal ? -1 : 1;
            var flipTranslateX = this.layer.flipHorizontal ? -this.layer.width : 0;
            var flipScaleY = this.layer.flipVertical ? -1 : 1;
            var flipTranslateY = this.layer.flipVertical ? -this.layer.height : 0;

            transform += "scale(" + flipScaleX + " " + flipScaleY + "),"
            transform += "translate(" + flipTranslateX + " " + flipTranslateY + "),";
        }

        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + ")";

        return transform;
    }

    private get isShadow()
    {
        return this.layer.isShadow;
    }

    private get shadowBlurFilterId()
    {
        return "shadowBlur_" + this.uuid;
    }

    private get blurFilterUrl()
    {
        return "url(#" + this.shadowBlurFilterId + ")";
    }

    private get imageFilterId()
    {
        return "imageFilter_" + this.uuid;
    }

    private get imageFilterUrl()
    {
        //! Chrome/Chroimumでフィルタを使用した時に出力時の画質が下がるので対処
        //! フィルタありの場合は下がってしまうがひとまず放置
        if (MathHelper.equals(this.layer.blur, 0) &&
            MathHelper.equals(this.layer.colorFilterR, 0) &&
            MathHelper.equals(this.layer.colorFilterG, 0) &&
            MathHelper.equals(this.layer.colorFilterB, 0)) {
            return "";
        } else {
            return "url(#" + this.imageFilterId + ")";
        }
    }

    private get trimClipPathId()
    {
        return "trimClipPath_" + this.uuid;
    }

    private get trimClipPathClippedId()
    {
         return "trimClipPathClipped_" + this.uuid;
    }

    private get trimRect()
    {
        var x = this.layer.trimRectNormalized.x / 100;
        var y = this.layer.trimRectNormalized.y / 100;
        var w = this.layer.trimRectNormalized.width / 100;
        var h = this.layer.trimRectNormalized.height / 100;
        return new Rectangle(x, y, w, h);
    }

    private get clipPath()
    {
        return this.layer.clipShapeSvgPath;
    }

    private get clipPathTransform()
    {
        var transform = "";

        // 移動
        transform += "translate(" + this.trimRect.x + " " + this.trimRect.y + "),";

        // 100 -> 領域に拡大する
        var scaleX = this.trimRect.width / 100;
        var scaleY = this.trimRect.height / 100;
        transform += "scale(" + scaleX + " " + scaleY + ")";

        return transform;
    }

    private get clipPathUrl()
    {
        if(!this.layer.isTrim) { return ""; }

        // トリミング中かつカレントならクリップしない
        var editMode = this.$store.getters.applicationState.editMode;
        var isCurrent = this.layer.id == this.$store.getters.applicationState.lastTrimLayerId;
        if(editMode == 4 && isCurrent) { return ""; }

        var id = this.layer.isClip ? this.trimClipPathClippedId : this.trimClipPathId;
        return "url(#" + id + ")";
    }

    private get colorFilterValues()
    {
        var values = "1 0 0 0 " + this.layer.colorFilterR / 255 + " ";
        values += "0 1 0 0 " + this.layer.colorFilterG / 255 + " ";
        values += "0 0 1 0 " + this.layer.colorFilterB / 255 + " ";
        values += "0 0 0 1 0";
        return values;
    }

    private get shadowBlurStdDeviation()
    {
        // 出力時は影を弱くする
        var path = this.$router.currentRoute.path;
        var fix = path == "/PrintSetting" && this.isRendering ? 0.2 : 1;
        return this.layer.shadowBlur / 10 * fix;
    }

    private get imageBlurStdDeviation()
    {
        return this.layer.blur / 80;
    }

    private get shadowRect()
    {
        var startX = this.layer.x * this.scale + this.offsetX;
        var startY = this.layer.y * this.scale + this.offsetY;
        // 左上の基準点
        var topLeft = new Vector2(startX + this.layer.shadowDistance * this.scale, startY);
        // 回転
        var rotatedTopLeft = topLeft.rotateDegrees(this.layer.shadowRotate, startX, startY);
        // 矩形を作成
        return new Rectangle(rotatedTopLeft.x, rotatedTopLeft.y, this.layer.width * this.scale, this.layer.height * this.scale);
    }

    private get shadowTransform()
    {
        var transform = "";

        var startX = this.layer.x * this.scale + this.offsetX;
        var startY = this.layer.y * this.scale + this.offsetY;

        // オフセット
        transform += "translate(" + startX + " " + startY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + "),";

        transform += "translate(" + -startX + " " + -startY + ")";

        return transform;
    }

    private get shadowColor()
    {
        var r = this.layer.shadowColor.r;
        var g = this.layer.shadowColor.g;
        var b = this.layer.shadowColor.b;
        var a = MathHelper.clamp(this.layer.shadowIntensity / 100, 0, 1);

        return "rgba(" + r + "," + g + "," + b + "," + a + ")";
    }

    onDragStart(event){
        event.preventDefault()
    }
}
